import { Elements, ElementsConsumer } from '@stripe/react-stripe-js'
import { Stripe } from '@stripe/stripe-js'
import { loadStripe } from '@stripe/stripe-js/pure'
import React from 'react'
import { useSelector } from 'react-redux'

import { Option } from '@/app/component/form/types'
import { selectUserName } from '@/app/module/user/store/selectors'
import { selectCountryNames } from '@/app/module/utils/store/selectors'
import { RootState } from '@/app/store'
import config from '@/config'

import PaymentForm from './form'

type Props = {
  amount?: number
  minimum?: number | string
}

const { stripe: stripeConfig, vendor } = config

const fontsUrl = vendor.css.find((item) => item.name === 'font-main')?.url || ''

let stripePromise: Promise<Stripe | null> | null = null

const Payment: React.FC<Props> = ({ amount, minimum }) => {
  const countries = useSelector(selectCountryNames) as Option[]
  const userName = useSelector(selectUserName) as string
  const userEmail = useSelector((state: RootState) => state?.user?.details?.data?.email || '') as string
  const error = useSelector((state: RootState) => state?.user?.details?.error) as any

  React.useEffect(() => {
    if (!stripePromise && stripeConfig.key) {
      loadStripe.setLoadParameters({ advancedFraudSignals: false })
      stripePromise = loadStripe(stripeConfig.key)
    }
  }, [])

  return (
    <Elements options={{ fonts: [{ cssSrc: fontsUrl }] }} stripe={stripePromise}>
      <ElementsConsumer>
        {({ elements, stripe }) => (
          <PaymentForm
            amount={amount}
            countries={countries}
            elements={elements}
            error={error}
            minimum={minimum}
            stripe={stripe}
            user={{ name: userName, email: userEmail }}
          />
        )}
      </ElementsConsumer>
    </Elements>
  )
}

export default Payment
